import React, { FC } from "react"

import { DeviceDocument } from "../../../../contexts/devices-context"
import UploadModuleSettings from "./UploadModuleSettings"
import useModuleAttributes from "../../hooks/useModuleAttributes"

type DeviceUploadModuleSettingsProps = {
    device: DeviceDocument
}

const _DeviceUploadModuleSettings: FC<DeviceUploadModuleSettingsProps> = ({ device }) => {
    const attrs = useModuleAttributes<"limit_to_days_ago" | "upload_minimum_interval">(device, "upload_client")

    return (
        <UploadModuleSettings
            attrs={attrs}
            organisation={device.organisation}
            group={device.group}
            device={device}
        />
    )
}

export default _DeviceUploadModuleSettings
